import { Icon, Story, Wrapper, Link } from "@wfp/ui"
import { iconWarningSolid } from "@wfp/icons"

export default function NoAccessPage() {
  return (
    <Wrapper pageWidth="lg" spacing="md">
      <Story className="wfp--story__center wfp--story__full-height">
        <Icon
          icon={iconWarningSolid}
          description=""
          fill="#007DBC"
          width="100"
          height="100"
          style={{
            marginBottom: "3rem",
          }}
        />
        <h1 className="wfp--story__title">Not authorized</h1>
        <p>
          {/* eslint-disable-next-line react/no-unescaped-entities */}
          You don't have access rights for DataBridges.
          <br />
          To request access please write to <Link href="mailto:wfp.vaminfo@wfp.org">wfp.vaminfo@wfp.org</Link>.<br />
          Go back to <Link href="/">Homepage</Link>
        </p>
      </Story>
    </Wrapper>
  )
}
